module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Radio-51eff7fe3274f872fde5eacbdeedacab.svg";